// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"405":"5ffec33c","655":"cde8fa54"}[chunkId] + ".chunk.js";
};